import React from 'react'
import { useSelector } from 'react-redux'
import styled from '@emotion/styled'
import { downloadUrl } from 'utils'
import { Locale, Translation } from 'locale'
import { useModal } from 'view/shared/modal'
import { SplitButtonDropdown, SplitButtonType, ActionItem } from 'view/components/menus'
import { MidTradeEventUploadDialog } from 'view/shared/midTradeEventUpload'
import {
  canUploadMidTradeEventsSelector,
  MID_TRADE_VIEW_HISTORICAL,
  MID_TRADE_VIEW_INCOMING,
  MID_TRADE_VIEW_INITIATED
} from 'selectors/midTradeEventsSelectors'
import midTradeEventUploadTemplateUrl from '../assets/MidTradeEventUploadTemplate.xlsx'
import midTradeResponseUploadTemplateUrl from '../assets/MidTradeResponseUploadTemplate.xlsx'

const SplitButtonStyled = styled(SplitButtonDropdown)`
  max-width: 150px;
`

export const MidTradeEventsToolbar = ({
  view
}: {
  view?: typeof MID_TRADE_VIEW_HISTORICAL | typeof MID_TRADE_VIEW_INITIATED | typeof MID_TRADE_VIEW_INCOMING
}) => {
  const canUpload = useSelector(canUploadMidTradeEventsSelector)
  const { showModal } = useModal()

  const uploadSpreadsheetHandler = (incoming?: boolean) => () => {
    showModal(<MidTradeEventUploadDialog incoming={incoming} />)
  }

  const handleDownloadSpreadsheet = () => {
    downloadUrl(midTradeEventUploadTemplateUrl, Locale.translate(Translation.TC_DOWNLOAD_MTE_TEMPLATE_FILENAME))
  }

  const handleDownloadResponseSpreadsheet = () => {
    downloadUrl(midTradeResponseUploadTemplateUrl, Locale.translate(Translation.TC_DOWNLOAD_MTE_RESPONSE_TEMPLATE_FILENAME))
  }

  if (!canUpload || view === MID_TRADE_VIEW_HISTORICAL) {
    return null
  }

  const toolbarActions: ActionItem[] = [
    {
      label: Locale.translate(Translation.TC_ACTION_UPLOAD_EVENTS),
      type: SplitButtonType.Primary,
      onClick: uploadSpreadsheetHandler(),
      enabled: view === undefined || view === MID_TRADE_VIEW_INITIATED
    },
    {
      label: Locale.translate(Translation.TC_ACTION_UPLOAD_RESPONSES),
      type: SplitButtonType.Primary,
      onClick: uploadSpreadsheetHandler(true),
      enabled: view === undefined || view === MID_TRADE_VIEW_INCOMING
    },
    {
      label: Locale.translate(Translation.TC_ACTION_DOWNLOAD_SPREADSHEET),
      type: SplitButtonType.Primary,
      onClick: handleDownloadSpreadsheet,
      enabled: view === undefined || view === MID_TRADE_VIEW_INITIATED
    },
    {
      label: Locale.translate(Translation.TC_ACTION_DOWNLOAD_RESPONSE_SPREADSHEET),
      type: SplitButtonType.Primary,
      onClick: handleDownloadResponseSpreadsheet,
      enabled: view === undefined || view === MID_TRADE_VIEW_INCOMING
    }
  ]

  return <SplitButtonStyled dataTestId={toolbarActions[0].label} actions={toolbarActions} maxButtons={1} />
}
